import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
// axios and toast not needed for mock data here
import { ReusableDataGrid } from "../components/shared/ReusableDataGrid";
import { Chip } from "@mui/material";

interface Medication {
  row_number: number;
  name: string;
  startDate: string;
  endDate: string;
  dosage: string;
  quantity: string;
  providerName: string;
  providerEmail: string;
  providerNo: string;
  status: string;
}

const statusColors: Record<string, { bg: string; color: string }> = {
  Active: { bg: "rgba(31, 181, 81, 0.1)", color: "#1FB551" }, // stable
  Completed: { bg: "rgba(255, 169, 77, 0.1)", color: "#FFA94D" }, // rescheduled
};

export default function MedicationTable() {
  const [data, setData] = useState<Medication[]>([]);

  useEffect(() => {
   const mockData: Medication[] = [
  {
    row_number: 1,
    name: "Abilify",
    startDate: "05/12/2025",
    endDate: "07/12/2025",
    dosage: "Twice in a day",
    quantity: "1 Tablet",
    providerName: "Dr. Mehmet Oz",
    providerEmail: "Mehmet.oz@healthcare.com",
    providerNo: "+1 (212) 555-1234",
    status: "Active",
  },
  {
    row_number: 2,
    name: "Lipitor",
    startDate: "06/01/2025",
    endDate: "09/01/2025",
    dosage: "Once a day",
    quantity: "2 Tablets",
    providerName: "Dr. Susan Black",
    providerEmail: "susan.black@healthcare.com",
    providerNo: "+1 (310) 555-5678",
    status: "Active",
  },
  {
    row_number: 3,
    name: "Metformin",
    startDate: "04/15/2025",
    endDate: "08/15/2025",
    dosage: "Twice in a day",
    quantity: "1 Tablet",
    providerName: "Dr. John Smith",
    providerEmail: "john.smith@healthcare.com",
    providerNo: "+1 (646) 555-9012",
    status: "Completed",
  },
  {
    row_number: 4,
    name: "Zoloft",
    startDate: "07/10/2025",
    endDate: "10/10/2025",
    dosage: "Once a day",
    quantity: "1 Capsule",
    providerName: "Dr. Emily Rose",
    providerEmail: "emily.rose@healthcare.com",
    providerNo: "+1 (415) 555-3456",
    status: "Active",
  },
  {
    row_number: 5,
    name: "Amoxicillin",
    startDate: "08/01/2025",
    endDate: "08/10/2025",
    dosage: "Three times a day",
    quantity: "1 Tablet",
    providerName: "Dr. Rajesh Mehta",
    providerEmail: "rajesh.mehta@healthcare.com",
    providerNo: "+1 (305) 555-7890",
    status: "Completed",
  },
];

    setData(mockData);
  }, []);

  // fetchMedications is intentionally omitted; using mock data above

  const columns: GridColDef[] = [
    { field: "row_number", headerName: "No", width: 80 },
    { field: "name", headerName: "Name", width: 150 },
    { field: "startDate", headerName: "Start Date", width: 130 },
    { field: "endDate", headerName: "End Date", width: 130 },
    { field: "dosage", headerName: "Dosage", width: 150 },
    { field: "quantity", headerName: "Quantity", width: 120 },
    { field: "providerName", headerName: "Provider Name", width: 160 },
    { field: "providerEmail", headerName: "Provider Email", width: 200 },
    { field: "providerNo", headerName: "Provider No", width: 140 },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const colors = statusColors[params.value as string] || {
          bg: "#eee",
          color: "#333",
        };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              backgroundColor: colors.bg,
              color: colors.color,
              fontWeight: 500,
            }}
          />
        );
      },
    },
  ];

  return (
    <div style={{ height: 500, width: "100%" }}>
      <ReusableDataGrid<Medication>
        columns={columns}
        data={data}
        onSelectionChange={(ids: any, rows: any) => {
          console.log("Selected rows", ids, rows);
        }}
        getRowId={(row: any) => row.row_number}
      />
    </div>
  );
}
